import React from 'react';
import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import EditMutation from 'mutations/inspection_subject/edit';
import Form from 'components/inspection_subject/form';

const Edit = ({ handleClose, onSuccess, inspectionSubject }) => {
  const setError = useError();
  const [editMutation, { loading }] = useMutation(EditMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.inspection_subject.edit');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection_subject.edit" />
      </ModalTypography>
      <Form
        initialValues={{
          id: inspectionSubject.id,
          name: inspectionSubject.name,
          serialNumber: inspectionSubject.serialNumber,
          placeId: inspectionSubject.place.id,
        }}
        processing={loading}
        onSubmit={(values) => editMutation({ variables: values })}
        onCancel={handleClose}
      />
    </>
  );
};

export default Edit;
